import { useState } from "react";
import MultiFileUploader from "../../../common/MultiFileUploader";
import Drawer from "../../../drawer/Drawer";
import { mediaExtensions } from "../../../constant/constant";
import { toast } from "react-toastify";
import { fileAddEdit } from "../../../../services/mediaService";
import { useSearchParams } from "react-router-dom";
import Button from "../../../form/Button";
import Input from "../../../form/Input";
import { supportedLanguages } from "../../../../helpers";
import LanguageTabs from "../../../elements/LanguageSwitcher";

const ManageFile = ({ open, close = () => {}, getResponse = () => {}, data = {} }) => {
  const [selectedFile, setSelectedFile] = useState([]);
  const [progress, setProgress] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const folderData = searchParams.get("folderData");
  const [loading, setLoading] = useState(false);
  const [currentLang, setCurrentLang] = useState(localStorage.getItem("lang") || "en");

  const [content, setContent] = useState(
    supportedLanguages.reduce((acc, lang) => {
      acc[lang.code] = {
        caption: data?.content?.[lang.code]?.caption,
        altText: data?.content?.[lang.code]?.altText,
      };
      return acc;
    }, {})
  );

  const handleLangChange = (lang) => {
    setCurrentLang(lang);
  };

  const handleFile = (newFileList) => {
    if (!newFileList || newFileList.length === 0) return;

    const allowedExtensions = Object.values(mediaExtensions).flat();

    const validFiles = [];

    for (const file of newFileList) {
      const fileExtension = "." + file.name.split(".").pop().toLowerCase();

      if (allowedExtensions.includes(fileExtension)) {
        validFiles.push(file);
      } else {
        toast.warning(`"${file.name}" is not an allowed file type.`);
      }
    }

    if (validFiles.length > 0) {
      setSelectedFile(validFiles); // ✅ set all valid files
      // sendFiles(validFiles);     // optionally send them
    }
  };

  const onSubmit = async () => {
    if (!selectedFile || selectedFile.length === 0) {
      toast.error("Please select at least one file.");
      return;
    }

    setLoading(true);

    const payload = {
      media: selectedFile,
      lang:localStorage.getItem('lang'),
      slug:`${content?.[currentLang]?.caption.replace(/\s+/g, "-").toLowerCase()}-${Date.now()}`,
      captions:content,
      ...(data?._id && { id: data?._id }),
      ...(folderData && folderData !== "root" && { key: folderData }),
    };

    try {
      const result = await fileAddEdit(payload, setProgress);
      if (result?.status === 200 || result?.status === 201) {
        toast.success(result.message || "File saved successfully");
        getResponse(result);
        close = () => {};
      } else {
        toast.error(result.message || "Failed to save file");
      }
    } catch (error) {
      toast.error(error.message || "Failed to save file");
    } finally {
      setSelectedFile([]);
      setLoading(false);
      setProgress(0);
    }
  };

  return (
    <>
      <Drawer
        open={open}
        onClose={(val) => {
          close(val);
        }}
        actualSize={"xl"}
        size={"xl6"}
        title={"Upload File"}
        subtitle=""
        drawerBodyClass="p-0 max-h-[calc(100%-90px)]"
      >
        <div className="h-full overflow-y-auto p-3">
          <LanguageTabs languages={supportedLanguages} defaultLang="en" value={currentLang} onChange={handleLangChange} />
          <div className="mb-4">
            <Input
              label="Caption"
              labelClasses={"rounded-2xl"}
              inputPlaceholder={"Add caption"}
              value={content?.[currentLang]?.caption || ""}
              onChange={(e) =>
                setContent({
                  ...content,
                  [currentLang]: {
                    ...content[currentLang],
                    caption: e.target.value,
                  },
                })
              }
            />
          </div>
          <div className="mb-4">
            <Input
              label="Alt Text"
              inputPlaceholder={"Insert alt text"}
              value={content?.[currentLang]?.altText || ""}
              onChange={(e) =>
                setContent({
                  ...content,
                  [currentLang]: {
                    ...content[currentLang],
                    altText: e.target.value,
                  },
                })
              }
            />
          </div>
          <div className={"text-xs font-medium text-text-disabled font-CanelaDeck"}>Media</div>
          <MultiFileUploader handleFile={(file) => handleFile(file)} progress={progress} selectedFile={selectedFile} />
          <div className="flex justify-end pt-8">
            <Button
              buttonType="button"
              buttonClasses={"min-w-36 hover:bg-emerald-700"}
              buttonLabel={"Save"}
              {...(loading && {
                loading: true,
                buttonIconPosition: "left",
                isDisable: true,
              })}
              buttonFunction={() => onSubmit()}
            />
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default ManageFile;
